import type { TourSection } from './types';

export const webhookDeliveriesListSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Filtros de entregas',
    steps: [
      {
        target: '[data-tour="deliveries-filters"]',
        title: 'Filtros',
        content:
          'Filtra por cliente (para ver entregas a uno solo), por SKU, por estado (entregado / falló / reintentando) y por rango de fechas. Útil para investigar por qué un cliente no recibió un aviso.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado de entregas',
    steps: [
      {
        target: '[data-tour="deliveries-table"]',
        title: 'Tabla',
        content:
          'Cada fila es un aviso enviado a un cliente: a qué cliente, qué pasó (producto creado / actualizado / eliminado), de qué SKU, si llegó bien o falló, y cuántas veces se intentó. Click para ver el detalle completo.',
      },
    ],
  },
  {
    id: 'pagination',
    label: 'Paginación',
    steps: [
      {
        target: '[data-tour="deliveries-pagination"]',
        title: 'Navegar entre páginas',
        content:
          'En producción puede haber miles de entregas. Conviene filtrar primero por cliente o fecha antes de empezar a paginar.',
      },
    ],
  },
];

export const webhookDeliveryDetailSections: TourSection[] = [
  {
    id: 'request',
    label: 'Información enviada',
    steps: [
      {
        target: '[data-tour="delivery-request"]',
        title: 'Lo que el sistema envió',
        content:
          'Cuerpo del aviso que se le mandó al cliente: qué producto cambió, qué campos, valores nuevos. Si necesitas reproducir el envío manualmente, copia este contenido.',
      },
    ],
  },
  {
    id: 'response',
    label: 'Respuesta del cliente',
    steps: [
      {
        target: '[data-tour="delivery-response"]',
        title: 'Lo que respondió el cliente',
        content:
          'Lo que el sistema del cliente devolvió al recibir el aviso. Si fue error, el motivo aparece aquí. Sirve para diagnosticar problemas del lado del cliente.',
      },
    ],
  },
  {
    id: 'retries',
    label: 'Reintentar manual',
    steps: [
      {
        target: '[data-tour="delivery-retries"]',
        title: 'Reintentar envío',
        content:
          'Si el aviso falló, puedes volver a enviarlo manualmente desde aquí. El sistema ya hace reintentos automáticos antes de marcar como fallido — úsalo solo cuando ya pasaron todos los intentos.',
      },
    ],
  },
];
